import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const SchengenDPage = () => {
  useEffect(() => {
    document.title = 'Schengen D Tipi Vize | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Schengen D tipi uzun süreli vize başvuruları. Çalışma, eğitim ve uzun dönem ikamet vizelerinde profesyonel danışmanlık hizmeti.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/15f86fb5f55311267b0ad247aea3e855.jpg"
              alt="Schengen D Vize"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>
          
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              Uzun Süreli Vize
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              Schengen D Tipi Vize Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              Çalışma, eğitim ve uzun dönem ikamet amaçlı ulusal vizelerde profesyonel destek
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Schengen D Tipi Vize Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                Schengen D tipi vize, ulusal vize olarak da bilinir ve 90 günden uzun süreli kalışlar için düzenlenir. Bu vize türü ile çalışma, eğitim, aile birleşimi veya uzun süreli ikamet amacıyla Schengen ülkelerinde bulunabilirsiniz. D tipi vize, başvurulan ülkenin ulusal mevzuatına göre düzenlenir ve genellikle 1 yıla kadar geçerlilik süresine sahiptir.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                D tipi vize sahipleri, vize aldıkları ülkede uzun süreli kalabilir ve belirli koşullar altında diğer Schengen ülkelerine de kısa süreli seyahatler yapabilirler. Bu vize türü, genellikle oturum iznine dönüştürülebilir ve uzun vadeli yaşam planları için önemli bir adımdır.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                D Tipi Vize Türleri
              </h2>
              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8">
                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-briefcase-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Çalışma Vizesi</h3>
                  <p className="text-cream-200 text-sm">İş sözleşmesi veya çalışma izni olan kişiler için düzenlenir. İşveren sponsorluğu gerektirir.</p>
                </div>
                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-book-open-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Öğrenci Vizesi</h3>
                  <p className="text-navy-700 text-sm">Üniversite veya yüksekokul kabul belgesi olan öğrenciler için düzenlenir.</p>
                </div>
                <div className="bg-gradient-to-br from-cream-300 to-cream-200 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-group-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Aile Birleşimi</h3>
                  <p className="text-navy-700 text-sm">Ülkede yasal olarak ikamet eden aile üyelerine katılmak için düzenlenir.</p>
                </div>
                <div className="bg-gradient-to-br from-navy-800 to-navy-700 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-home-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Uzun Dönem İkamet</h3>
                  <p className="text-cream-200 text-sm">Emeklilik, yatırım veya diğer uzun süreli ikamet amaçları için düzenlenir.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Gerekli Evraklar
              </h2>
              <div className="bg-cream-50 rounded-2xl p-6 md:p-8 mb-8 border-2 border-cream-200">
                <h3 className="font-bold text-navy-900 text-xl mb-4">Genel Evraklar</h3>
                <ul className="space-y-3 text-navy-700 mb-6">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Geçerli pasaport (en az 6 ay geçerlilik süresi)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Eksiksiz doldurulmuş ulusal vize başvuru formu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Biyometrik fotoğraflar</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Sağlık sigortası (tüm kalış süresini kapsayan)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Mali yeterlilik belgeleri</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Konaklama belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Sabıka kaydı belgesi</span>
                  </li>
                </ul>

                <h3 className="font-bold text-navy-900 text-xl mb-4">Çalışma Vizesi İçin Ek Evraklar</h3>
                <ul className="space-y-3 text-navy-700 mb-6">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">İş sözleşmesi veya iş teklifi mektubu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Çalışma izni belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">İşveren firma bilgileri ve belgeleri</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Diploma ve mesleki yeterlilik belgeleri</span>
                  </li>
                </ul>

                <h3 className="font-bold text-navy-900 text-xl mb-4">Öğrenci Vizesi İçin Ek Evraklar</h3>
                <ul className="space-y-3 text-navy-700">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Üniversite kabul mektubu</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Eğitim ücretinin ödendiğine dair belge</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Dil yeterlilik belgesi</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-circle-fill text-cream-400 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">Önceki eğitim belgelerinin apostilli kopyaları</span>
                  </li>
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Başvuru Süreci ve Süreler
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                D tipi vize başvuruları, C tipi vizelere göre daha uzun süreçlidir ve daha detaylı inceleme gerektirir. Başvuru süreci genellikle şu adımları içerir:
              </p>
              <div className="space-y-4 mb-8">
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Detaylı Ön Değerlendirme (1-2 Hafta)</h3>
                      <p className="text-cream-200">Profiliniz, amacınız ve hedef ülke detaylı şekilde analiz edilir. Gerekli tüm evraklar belirlenir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Evrak Toplama ve Hazırlık (2-4 Hafta)</h3>
                      <p className="text-navy-700">Tüm belgeler toplanır, tercüme edilir, apostil işlemleri yapılır ve konsolosluk standartlarına uygun hale getirilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-navy-800 to-navy-700 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Randevu ve Başvuru (1-2 Hafta)</h3>
                      <p className="text-cream-200">Konsolosluktan randevu alınır ve başvuru yapılır. Biyometrik veriler kaydedilir.</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-cream-300 to-cream-200 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Değerlendirme Süreci (4-12 Hafta)</h3>
                      <p className="text-navy-700">Konsolosluk başvurunuzu inceler. Bu süre ülkeye ve vize türüne göre değişiklik gösterir.</p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Profesyonel Danışmanlık Avantajları
              </h2>
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <i className="ri-shield-star-fill text-4xl text-navy-900 mb-4"></i>
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Uzman Rehberlik</h3>
                  <p className="text-navy-600">10+ yıllık deneyimimiz ile karmaşık D tipi vize süreçlerinde size yol gösteriyoruz.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <i className="ri-file-list-3-fill text-4xl text-navy-900 mb-4"></i>
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Eksiksiz Evrak</h3>
                  <p className="text-navy-600">Tüm belgelerinizin konsolosluk kriterlerine uygun şekilde hazırlanmasını sağlıyoruz.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <i className="ri-time-fill text-4xl text-navy-900 mb-4"></i>
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Süreç Yönetimi</h3>
                  <p className="text-navy-600">Başvurunuzun her aşamasını takip ediyor ve sizi bilgilendiriyoruz.</p>
                </div>
                <div className="bg-cream-50 rounded-xl p-6 border-2 border-cream-200">
                  <i className="ri-customer-service-2-fill text-4xl text-navy-900 mb-4"></i>
                  <h3 className="font-bold text-navy-900 text-lg mb-2">7/24 Destek</h3>
                  <p className="text-navy-600">Sorularınız için her zaman ulaşılabilir durumdayız.</p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">D tipi vize ile ne kadar kalabilirim?</h3>
                  <p className="text-navy-600">D tipi vize genellikle 1 yıla kadar geçerlidir ve ülkede oturum iznine dönüştürülebilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">D tipi vize ile diğer Schengen ülkelerine gidebilir miyim?</h3>
                  <p className="text-navy-600">Evet, D tipi vize ile 180 gün içinde 90 güne kadar diğer Schengen ülkelerine seyahat edebilirsiniz.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Başvuru süreci ne kadar sürer?</h3>
                  <p className="text-navy-600">Evrak hazırlığı dahil toplam süreç 2-4 ay arasında değişebilir.</p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">Aile üyelerimi de getirebilir miyim?</h3>
                  <p className="text-navy-600">Evet, D tipi vize sahipleri belirli koşullar altında aile birleşimi başvurusu yapabilir.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              D Tipi Vize Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              Uzun süreli vize başvurularında profesyonel destek için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default SchengenDPage;